import { useMemo } from 'react';
import { useRouter } from 'next/router';
import CompactNavbar from './CompactNavbar';
import ExtendedNavbar from './ExtendedNavbar';
import SwitchCountryBanner from './SwitchCountryBanner';
import { useSuggestedCountry } from '@/lib/geolocation/useSuggestedCountry';
import { ACCESSORIES_ROUTE } from '@/lib/purchase-flow';

const Navbar = () => {
  const { pathname } = useRouter();

  const suggestedCountry = useSuggestedCountry();

  const isCompactNavbar = useMemo(
    () => ['/checkout/[checkoutId]', '/cart'].includes(pathname),
    [pathname],
  );

  if (pathname === ACCESSORIES_ROUTE) {
    return null;
  }

  return (
    <>
      {isCompactNavbar ? <CompactNavbar /> : <ExtendedNavbar />}
      {!isCompactNavbar && suggestedCountry && (
        <SwitchCountryBanner countryCode={suggestedCountry} />
      )}
    </>
  );
};

export default Navbar;
